import moment from 'moment';

const getDisabledDates = (dates, initialDates) => {
  let bookedDates = dates?.accommodations?.[0]?.bookedDates ?? [];

  if (initialDates) {
    bookedDates = bookedDates.filter(item => {
      const date = moment(item.date, 'YYYY-MM-DD');
      return !date.isBetween(
        initialDates.startDate,
        initialDates.endDate,
        'day',
        '[]'
      );
    });
  }

  return bookedDates;
};

export function getRange(startDate, endDate, type = 'days') {
  let fromDate = moment(startDate);
  let toDate = moment(endDate);
  let diff = toDate.diff(fromDate, type);
  let range = [];
  for (let i = 0; i <= diff; i++) {
    range.push(moment(startDate).add(i, type));
  }
  return range;
}

const getAvailableRangeDates = accommodation => ({
  startDate: accommodation?.generalForm?.availability?.startDate ?? null,
  endDate: accommodation?.generalForm?.availability?.endDate ?? null,
  daysOfWeek: []
});

export { getDisabledDates, getAvailableRangeDates };
